/* pm-icon motion (Poles Media, Vedic Shop v4). Switched off 11 Oct 2026 (owner note 18): no cart nudge,
   no trust draw-in, no toast tick, and no fetch/XHR hooks. Icons are static. The old script is backed up as
   assets/pmbak-20261011u-assets-pm-icon-motion.js.txt. The stub below keeps window.pmIconMotion for any caller. */
(function () {
  window.pmIconMotion = { cartUpdate: function () {}, unitLength: function () {} };
})();

/* PM 24 Oct 2026: anchor resolver. Buttons saved with a section id from another theme copy
   (#shopify-section-template--NNN__key) matched nothing. This finds the section by its stable key instead. */
(function () {
  function key(h) { var m = (h || '').match(/#shopify-section-template--\d+__(.+)$/); return m && m[1]; }
  function find(k) { return document.querySelector('[id$="__' + k + '"]'); }
  function go(k) {
    var el = find(k);
    if (!el) return false;
    var y = el.getBoundingClientRect().top + window.pageYOffset - 70;
    window.scrollTo({ top: y < 0 ? 0 : y, behavior: 'smooth' });
    return true;
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href*="#shopify-section-template--"]');
    if (!a) return;
    var u = new URL(a.getAttribute('href'), location.href);
    if (u.pathname !== location.pathname) return;
    var k = key(u.hash);
    if (k && go(k)) e.preventDefault();
  }, true);
  function onLoad() {
    var k = key(location.hash);
    if (k && !document.getElementById(location.hash.slice(1))) setTimeout(function () { go(k); }, 400);
  }
  if (document.readyState === 'complete') onLoad(); else window.addEventListener('load', onLoad);
})();

/* PM 24 Oct 2026: legacy link repoint. The store sells the legacy pages; pm- twins stay unlisted.
   Any link to a pm- product that has a legacy twin is pointed at the legacy page. pm- ritual products have no twin and are left alone. */
(function () {
  var MAP = {
    'pm-karungali-mala-with-rudraksha-beads': 'karungali-mala-with-rudraksha-beads-gold-plated',
    'pm-om-bracelet-for-men-steel': 'om-bracelet-for-men-steel',
    'pm-om-bracelet-for-men': 'om-bracelet-for-men',
    'pm-double-layer-rudraksha-bracelet': 'double-layer_rudraksha-bracelet',
    'pm-double-layer-rudraksha-bracelet-7-mukhi-pendant': 'powerful-double-layer-gold-plated-rudraksha-bracelet-with-7-mukhi-rudraksha-pendent',
    'pm-miniature-wooden-hanuman-chalisa-book': 'wooden_hanuman_chalisa',
    'pm-natural-pyrite-cluster': 'natural_pyrite-cluster',
    'pm-aries-zodiac-red-jasper-tigers-eye-bracelet': 'aries-मेष-राशि-zodiac-carnelian-garnet-bracelet',
    'pm-taurus-zodiac-sunstone-carnelian-bracelet': 'taurus-वृषभ-राशि-zodiac-sunstone-carnelian-bracelet',
    'pm-gemini-zodiac-green-aventurine-milky-quartz-bracelet': 'gemini-मिथुन-राशि-zodiac-citrine-amp-aquamarine-bracelet',
    'pm-cancer-zodiac-howlite-milky-quartz-bracelet': 'cancer-कर्क-राशि-zodiac-moonstone-amp-aquamarine-bracelet',
    'pm-leo-zodiac-tiger-eye-citrine-bracelet': 'leo-सिंह-राशि-zodiac-tiger-eye-sunstone-bracelet',
    'pm-virgo-zodiac-carnelian-milky-quartz-bracelet': 'virgo-कन्या-राशि-zodiac-amazonite-amethyst-bracelet',
    'pm-libra-zodiac-lapis-lazuli-howlite-bracelet': 'libra-तुला-राशि-zodiac-lapis-lazuli-amp-howlite-bracelet',
    'pm-scorpio-zodiac-black-obsidian-milky-quartz-bracelet': 'scorpio-वृश्चिक-राशि-zodiac-black-obsidian-milky-quartz-bracelet',
    'pm-sagittarius-zodiac-black-obsidian-lapis-lazuli-bracelet': 'sagittarius-धनु-राशि-zodiac-black-obsidian-lapis-lazuli-bracelet',
    'pm-capricorn-zodiac-garnet-milky-quartz-bracelet': 'capricorn-मकर-राशि-zodiac-garnet-milky-quartz-bracelet',
    'pm-aquarius-zodiac-amethyst-blue-stone-bracelet': 'aquarius-कुंभ-राशि-zodiac-amethyst-blue-stone-bracelet',
    'pm-pisces-zodiac-tiger-eye-citrine-bracelet': 'pisces-मीन-राशि-zodiac-tiger-eye-citrine-bracelet'
  };
  function legacy(h) {
    try { h = decodeURIComponent(h); } catch (e) {}
    if (MAP[h]) return MAP[h];
    if (/^pm-numero-bracelet-ruling-number-\d-[a-z]+$/.test(h)) return h.slice(3);
    return null;
  }
  function fix(root) {
    var list = (root || document).querySelectorAll('a[href*="/products/pm-"]');
    for (var i = 0; i < list.length; i++) {
      var a = list[i], href = a.getAttribute('href');
      var m = href.match(/^(.*\/products\/)(pm-[^?#\/]+)(.*)$/);
      if (!m) continue;
      var t = legacy(m[2]);
      if (t) a.setAttribute('href', m[1] + t + m[3]);
    }
  }
  function start() {
    fix(document);
    if (window.MutationObserver) new MutationObserver(function () { fix(document); }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
